import { DEPLOYED_CONTRACTS as EVM_DEPLOYED_CONTRACTS } from '../chains/evm/deployed-address';
import { SVMChain } from '../types';
import { getEvmChainPreset, getEvmRpcList } from './evm-registry';
export const THIRD_WEB_ID = process.env.REACT_APP_THIRDWEB_CLIENT_ID ?? process.env.THIRDWEB_CLIENT_ID;
export const DEFAULT_SOLANA_RPC = [
    process.env.REACT_APP_SOLANA_RPC_URL,
    'https://api.mainnet-beta.solana.com',
].filter(Boolean);
export const AVAILABLE_EVM_CHAINS = Object.keys(EVM_DEPLOYED_CONTRACTS);
export const AVAILABLE_CHAINS = [...AVAILABLE_EVM_CHAINS];
function buildEvmChainInfo(chain) {
    const preset = getEvmChainPreset(chain);
    return {
        chainId: preset.id,
        explorer: preset.blockExplorers?.default?.url ?? '',
        rpc: getEvmRpcList(chain),
        contracts: EVM_DEPLOYED_CONTRACTS[chain],
    };
}
export const WEB3_ADDRESS = {
    [SVMChain.Solana]: {
        rpc: DEFAULT_SOLANA_RPC.length ? DEFAULT_SOLANA_RPC : ['https://api.mainnet-beta.solana.com'],
        chainId: 101,
        explorer: 'https://solscan.io',
    },
};
for (const chain of AVAILABLE_EVM_CHAINS) {
    WEB3_ADDRESS[chain] = buildEvmChainInfo(chain);
}
export const isEVMChain = (chainName) => {
    if (!chainName)
        return false;
    return AVAILABLE_EVM_CHAINS.includes(chainName);
};
export const getSolanaRpcList = () => {
    return WEB3_ADDRESS[SVMChain.Solana]?.rpc ?? DEFAULT_SOLANA_RPC;
};
